module.exports = __webpack_public_path__ + "static/media/logo-conlicitacao-banner-branco.b3eeafb7.svg";